import { Chip } from '@mui/material'
import { CONNECTION_UI_STATE } from '@/features/integrations'

/**
 * What state a connection is actually in.
 *
 * This replaces an invented seven-day usage sparkline, which drew a chart from
 * a hash of the row id. The row already carried `status` and never showed it,
 * so an expired connection looked exactly like a working one — the user's only
 * clue was the agent failing later.
 */
const BY_STATE = {
  [CONNECTION_UI_STATE.connected]: { label: 'Connected', color: 'success' },
  [CONNECTION_UI_STATE.authorizing]: { label: 'Authorising', color: 'warning' },
  [CONNECTION_UI_STATE.reauthRequired]: { label: 'Reconnect needed', color: 'warning' },
  [CONNECTION_UI_STATE.failed]: { label: 'Failed', color: 'error' },
  [CONNECTION_UI_STATE.notConnected]: { label: 'Inactive', color: 'default' },
}

export default function ConnectionStatusChip({ uiState }) {
  const chip = BY_STATE[uiState] ?? BY_STATE[CONNECTION_UI_STATE.notConnected]
  return <Chip size="small" variant="outlined" label={chip.label} color={chip.color} />
}
